import React from 'react';
import { ReactComponent as DoneAll } from '../../assets/icons/doneAll.svg'
import SvgIcon from '@material-ui/core/SvgIcon'
import { useStyles } from '../report.style'


export const DoneAllIcon = () => {
    const classes = useStyles();
    return( 
        <SvgIcon 
            component={DoneAll}  
            className={classes.doneAll} 
            viewBox="0 0 1200 1200" 
            width="50" 
            height="50" 
        />
    );
}

